/* istanbul ignore file */
import OAuthPasswordGrant from "../authentication/oauth-password-grant";
import { ContentHubClient } from "../clients/content-hub-client";

/** @internal */
export class IntegrationTestHelper {
    static async client(): Promise<ContentHubClient> {
        const oauthGrant = new OAuthPasswordGrant(
            process.env.OAUTH_CLIENT_ID as string,
            process.env.OAUTH_CLIENT_SECRET as string,
            process.env.USER_NAME as string,
            process.env.USER_PASSWORD as string
        );

        const client = new ContentHubClient(process.env.ENDPOINT as string, oauthGrant);

        await client.internalClient.authenticateAsync();

        return client;
    }
}
